// Component to display the Schedule Scene extra info
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styles from "../../../styles/ScheduleCreate.module.css";

const SchedSceneInfo2 = (props) => {
    const { location_address, action,
             day_night,
            equip_set_props, new_info,
            department_info  } = props;

    return (
        <div className={`text-center py-2 mb-2 mx-2 px-2 ${styles.SceneBox}`}>
        {/* day - description */}
        <Row className='text-center'>
        <Col className={`${styles.BorderRight} mx-0 px-1 mb-0 pb-1`} xs={12} md={3} >
        <p className={`mb-2 mx-2 mx-md-5 ${styles.BoldTitle}`} >
            DAY/NIGHT</p>
        <div className={`${styles.Hig20}`}>
            <p className='pb-0 pb-sm-0'>{day_night} </p>
        </div>
        <hr className={`d-block d-md-none mt-1 mb-0`}/>
        </Col>
        <Col xs={12} md={9} className={`mt-2 mx-0 px-3 mb-0 pb-1`} >
        <p className={`mb-2 mx-5 ${styles.BoldTitle}`}>
        DESCRIPTION</p>
        <div className={`${styles.Hig20}`}>
        <p className='pb-0'>{action} </p>
        </div>
        <hr className={`d-block d-md-none mt-1 mb-0`}/>
        </Col>
        </Row>
        {/* hr */}
        <Row>
        <Col xs={12}>
        <hr className={`d-none d-md-block mt-0 mb-0`}/>
        </Col>
        </Row>
        {/* address day */}
        <Row className='text-center'>
        <Col xs={12} md={6} className={`mt-2 mx-0 px-1 mb-0 pb-1 ${styles.BorderRight}`} >
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`} >
            FILMING ADDRESS </p>
            <div className={`${styles.Hig20}`}>
            <p className=''>{location_address} </p>
            </div>
            <hr className={`d-block d-md-none mt-0 mb-0`}/>
        </Col>
        <Col className={`mt-2 mx-0 px-1 mb-0 pb-1`} xs={12} md={6} >
        <p className={`mb-2 mx-5 ${styles.BoldTitle}`}>
            SHOOT INFO </p>
        <div className={`${styles.Hig20}`}>
        <p >{new_info} </p>
        </div>
        <hr className={`d-block d-md-none mt-1 mb-0`}/>
        </Col>
        </Row>
        {/* hr */}
        <Row>
        <Col xs={12}>
        <hr className={`d-none d-md-block mt-0 mb-0`}/>
        </Col>
        </Row>
        {/* EQUIP/SET/PROPS - SFX/stunts */}
        <Row className='text-center'>        
            <Col className={`mt-2 mx-0 px-1 mb-0 pb-1`} xs={12} md={6}>
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`} >
                EQUIP/SET/PROPS</p>
            <div className={`${styles.Hig20}`}>
            <p >{equip_set_props} </p>
            </div>
            <hr className={`d-block d-md-none mt-1 mb-0`}/>
            </Col>
            <Col className={`mt-2 mx-0 px-1 mb-0 pb-1`} xs={12} md={6}>
            <p className={`mb-2 mx-5 ${styles.BoldTitle}`} >
                SFX/STUNTS</p>
            <div className={`${styles.Hig20}`}>
            <p >{department_info} </p>
            </div>
            <hr className={`d-block d-md-none mt-1 mb-0`}/>
            </Col>
        </Row>
        {/* hr */}
        <Row>
        <Col xs={12}>
        <hr className={`d-none d-md-block mt-0 mb-0`}/>
        </Col>
        </Row>
        </div>
    )
}

export default SchedSceneInfo2